import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "sonner";
import Header from "../components/Header";
import PortalBack from "../components/PortalBack";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PublicProfile() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const { user } = useAuth();
  const sendMessage = async () => {
    if (!user) { toast.error("Please sign in to send a private message."); return; }
    const [first, ...rest] = (user.name || "Member").split(" ");
    try {
      await api.post("/leads", { first_name: first, last_name: rest.join(" ") || null, email: user.email, interests: ["Private message request"],
        source_page: `list-profile:${p.name}`, message: `Private message request to ${p.name} (${p.role})` });
      toast.success("Private message request sent.");
    } catch { toast.error("Could not send. Please try again."); }
  };
  useEffect(() => { api.get(`/list/profiles/${id}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [id]);
  if (p === false) return <div className="min-h-screen bg-obsidian text-ivory pt-32 px-6"><PortalBack /><p className="mt-6">This profile is no longer available.</p></div>;
  if (!p) return <div className="min-h-screen bg-obsidian" />;
  return (
    <div className="min-h-screen bg-obsidian text-ivory">
      <Header variant="list" active="list" />
      <div className="pt-28 px-6 lg:px-10 max-w-6xl mx-auto"><PortalBack label="Back to Dashboard" /></div>
      <section className="pt-8 pb-16 px-6 lg:px-10 max-w-6xl mx-auto grid lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2">
          <div className="aspect-[4/5] overflow-hidden"><img src={p.image} alt={p.name} className="w-full h-full object-cover" /></div>
        </div>
        <div className="lg:col-span-3">
          <p className="eyebrow mb-4">{p.role} · {p.six_p} · {p.location}</p>
          <h1 className="font-display text-4xl lg:text-5xl tracking-tight">{p.name}</h1>
          <span className="inline-block mt-3 eyebrow !text-[0.55rem] border border-gold/50 px-3 py-1 text-gold" data-testid="profile-status">{p.status}</span>
          <p className="mt-5 font-headline italic text-xl text-ivory/80 leading-snug">{p.headline}</p>
          <p className="mt-6 text-ivory/70 leading-relaxed max-w-xl">{p.bio}</p>
          <div className="mt-6 flex flex-wrap gap-2">
            {p.tags.map((t) => <span key={t} className="eyebrow !text-[0.55rem] border border-gold/40 px-3 py-1">{t}</span>)}
          </div>
          <div className="mt-10 grid sm:grid-cols-3 gap-px bg-gold/20 border border-gold/20">
            <div className="bg-obsidian p-5"><p className="eyebrow mb-2">What They Offer</p><p className="text-sm text-ivory/80">{p.offering}</p></div>
            <div className="bg-obsidian p-5"><p className="eyebrow !text-aqua mb-2">What They Need</p><p className="text-sm text-ivory/80">{p.seeking}</p></div>
            <div className="bg-obsidian p-5"><p className="eyebrow mb-2">Where They Operate</p><p className="text-sm text-ivory/80">{p.where || p.location}</p></div>
          </div>
          <div className="mt-8 flex gap-3">
            <button data-testid="message-btn" onClick={sendMessage} className="btn-lux bg-gold text-obsidian hover:bg-ivory">Initiate Private Message</button>
            <Link to="/list/dashboard" className="btn-lux bg-transparent text-ivory hover:bg-white/5">View Leverage Links</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
